(function() {
	var search_form = document.querySelector(".rf-predictive-search form");
	var search_input = search_form.querySelector(".rf-predictive-search .search-field");

	if (!search_form || !search_input) return;

	// Toggle visibility of search form in header.
	document.querySelectorAll("#top a.header-trigger__link--search, #top a.secondary-nav__link--search").forEach(function(link) {
		link.addEventListener("click", function(e) {
			e.preventDefault();
			document.body.classList.toggle("search-results-is-open");
			if (document.body.classList.contains("search-results-is-open")) {
				window.setTimeout(function() {
					search_input.focus();
				}, 150);
			}
		});
	});

	// Hide search form if touched outside the header area.
	document.addEventListener("click", function(e) {
		if (null === e.target.closest(".shopify-section-header")) {
			document.body.classList.remove("search-results-is-open");
		}
	});

	// Don't init events if predictive search is not enabled to show live results.
	if (!search_form.classList.contains("live-results")) return;

	var typing_timer, typing_debounce = parseInt(search_form.dataset.debounce, 10);
	var loading_timer, loading_debounce = parseInt(typing_debounce / 2, 10);
	var search_term = search_input.value.toLowerCase();
	var search_products, search_posts;
	var fetching_timer, fetching_products = false,
		fetching_posts = false;

	// Clear search field when reset button is clicked.
	search_form.querySelector(".rf-search-reset").addEventListener("click", function(e) {
		e.preventDefault();
		search_input.value = "";
		search_input.focus();
		search_input.dispatchEvent(new Event("keyup"));
	});

	// Show/hide results while typing.
	search_input.addEventListener("keyup", function(e) {
		if (search_input.value.length > 0) {
			search_form.classList.add("search-has-input");
		} else {
			search_form.classList.remove("search-has-input");
		}
		if (search_term == (search_term = search_input.value.toLowerCase().trim()) && (27 !== e.keyCode)) {
			return;
		}

		if (search_term && search_term.length > 1 && (27 !== e.keyCode)) {
			// Open the results panel only if at least 2 characters are typed.
			clearTimeout(loading_timer);
			search_form.classList.add("search-loading");
		} else {
			if (27 === e.keyCode) {
				document.body.classList.remove("search-results-is-open");
			} else {
				search_form.classList.remove("search-show-results");
			}
			search_form.classList.remove("search-loading");
			return;
		}

		// Reset typing and fetching timer .
		clearTimeout(typing_timer);
		// Debounce typing event using a timer.
		typing_timer = setTimeout(function() {
			fetching_products = true;
			// Get max. 6 available products matching search term and options.
			fetch('/search/suggest.json?q=' + encodeURIComponent(search_term) + "&amp;resources[type]=product&amp;resources[limit]=6&amp;resources[options][unavailable_products]=show&amp;resources[options][fields]=title,product_type,tag,body")
				.then(function(response) {
					if (!response.ok) {
						throw new Error(response.status + " " + response.statusText);
					}
					return response.json();
				}).then(function(json) {
					// Get products from JSON.
					search_products = json.resources.results.products;
					// Build result markup.
					var products_markup = "",
						products_not_found = (search_products.length == 0);
					if (products_not_found) {
						products_markup = '<strong class="subtitle no-results">' + search_form.dataset.no_products + "</strong>";
					} else {
						products_markup = '<strong class="subtitle">' + search_form.dataset.products + "</strong>";
						products_markup += "<ul>";
						search_products.forEach(function(product) {
							products_markup += '<li><a href="' + product.url.split(/[?#]/)[0] + '">';
							products_markup += '<span class="has-thumb">';
							products_markup += '<img src="' + product.image + '&amp;width=150" width="150" height="150" loading="lazy" alt="">';
							if ("0.00" !== product.compare_at_price_min) {
								products_markup += '<span class="on-sale">' + search_form.dataset.products_on_sale + "</span>";
							}
							products_markup += "</span> ";
							products_markup += '<span class="text">';
							products_markup +=  '<span class="limit">' + rf_search_term_highlight(product.title, search_term) + "</span> ";
							products_markup +=  "<em>";
							if (product.price_min !== product.price_max) {
								products_markup += search_form.dataset.product_currency + product.price_min + " <span></span> " + search_form.dataset.product_currency + product.price_max;
							} else {
								products_markup += search_form.dataset.product_currency + product.price;
							}
							products_markup +=  "</em>";
							products_markup += "</span>";
							products_markup += "</a></li>";
						});
						products_markup += "</ul>";
					}
					var results = search_form.querySelector(".rf-search-results");
					results.innerHTML =
						'<div class="rf-search-results-products' + (products_not_found ? " no-result" : " has-results") + '">' + products_markup + "</div>" +
						'<div class="rf-search-results-posts' + (products_not_found ? " no-products" : "") + '"><span class="partial-loading"></span></div>' +
						'<div class="rf-more-search-results' + (products_not_found ? " no-products" : "") + '">' +
						'<a href="' + (products_not_found ? '/collections/all' : '/search?type=product&amp;q=' + encodeURIComponent(search_term)) + '" class="more-products">' + search_form.dataset.more_products + " <em></em></a>" +
						'<a href="' + (search_form.dataset.rest_more + encodeURIComponent(search_term)) + '" class="more-posts">' + search_form.dataset.more_articles + " <em></em></a>" +
						"</div>";
					// Show initial results for products only.
					results.classList.add("partial-results");
					// While waiting for articles (fromexternal REST).
					fetching_timer = setInterval(rf_timer_check_articles_ready, 20);
					search_form.classList.add("search-show-results");
				}).catch(function(error) {
					console.error(error);
					search_products = null;
					fetching_posts = false;
					// When first main fetch fails, we ignore the second one and display an error message.
					search_form.querySelector(".rf-search-results").innerHTML = '<strong class="subtitle no-results error">' + error + "</strong>";
					search_form.classList.add("search-show-results");
					rf_stop_loading_animation();
				}).finally(function() {
					fetching_products = false;
				});

			// Also load external articles (while loading products).
			clearTimeout(fetching_timer); // Reset fetching timer.
			fetching_posts = true;
			fetch(
				search_form.dataset.rest + encodeURIComponent(search_term), // + "&amp;limit=5",
				{
					signal: rf_abort_timeout(parseInt(search_form.dataset.rest_timeout, 10))
				}
			).then(function(response) {
				if (!response.ok) {
					throw new Error(response.status + " " + response.statusText);
				}
				return response.json();
			}).then(function(json) {
				search_posts = json.results;
			}).catch(function(error) {
				console.error(error);
				search_posts = null;
			}).finally(function() {
				fetching_posts = false;
			});

		}, typing_debounce);
	});

	function rf_timer_check_articles_ready() {
		// Check if fetching posts has finished.
		if (!fetching_posts) {
			clearTimeout(fetching_timer);
			rf_stop_loading_animation();

			var results = search_form.querySelector(".rf-search-results");
			results.classList.remove("partial-results");

			var posts_results = results.querySelector(".rf-search-results-posts");
			var posts_markup = "";
			if (search_posts && search_posts.length) {
				posts_markup = '<strong class="subtitle">' + search_form.dataset.articles + "</strong>";
				posts_markup += "<ul>";
				search_posts.forEach(function(post) {
					posts_markup += '<li><a href="' + post.link + '">';
					posts_markup += '<span class="has-thumb">' + post.thumbnail + "</span> ";
					posts_markup += '<span class="text">';
					posts_markup +=  '<span class="limit">' + rf_search_term_highlight(post.title, search_term) + "</span> ";
					posts_markup += "</span>";
					posts_markup += "</a></li>";
				});
				posts_markup += "</ul>";
				posts_results.classList.add("has-results");
			} else {
				search_form.querySelector(".rf-search-results .rf-search-results-products").classList.add("no-posts");
				search_form.querySelector(".rf-search-results .rf-more-search-results").classList.add("no-posts");
				if (search_products && search_products.length) {
					posts_markup = '<strong class="subtitle no-results">' + search_form.dataset.no_articles + "</strong>";
				} else {
					var products_subtitle = search_form.querySelector(".rf-search-results .rf-search-results-products .subtitle");
					products_subtitle.innerHTML = search_form.dataset.no_results;
					products_subtitle.classList.add("no-results");
				}
				posts_results.classList.add("no-result");
			}
			posts_results.innerHTML = posts_markup;
		}
	}

	// helper to allow fetch to timeout: https://stackoverflow.com/a/50101022
	function rf_abort_timeout(ms) {
		var ctrl = new AbortController();
		setTimeout(function() {
			ctrl.abort();
		}, ms);
		return ctrl.signal;
	}

	function rf_search_term_highlight(text, search_term) {
		var unaccented_characters = {
			"a": "[aàáâä]",
			"c": "[cç]",
			"e": "[eèéêë]",
			"i": "[iìíîï]",
			"o": "[oòóô]",
			"u": "[uùúû]",
		};
		var words = search_term.split(" ").map(function(str) {
			return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape any special regex characters.
		});
		var re = new RegExp("(<strong[^>]*>.*?<\/strong>)|" + words.map(function(word) {
			return word.length > 1 ? word.replace(/[aceiou]/g, function(match) {
				return unaccented_characters[match];
			}) : word;
		}).join("|"), "gi");

		return text.replace(re, function(match, strong) {
			return strong ? match : '<strong class="key">' + match + '</strong>';
		});
	}

	function rf_stop_loading_animation() {
		clearTimeout(loading_timer);
		loading_timer = setTimeout(function() {
			search_form.classList.remove("search-loading");
		}, loading_debounce);
	}

})();